export default class Classification {
  // TODO: clsListをstore-coreからAPI経由で取得するように修正する
  // TODO: APIのIF部分が修正されているので処理要修正
  static clsList = {
    gender_typ: {
      other: {
        typ: '00',
        typ_logical_nm: {
          ja: 'その他',
          en: 'other'
        },
        disp_order: 3
      },
      male: {
        typ: '01',
        typ_logical_nm: {
          ja: '男性',
          en: 'man'
        },
        disp_order: 1
      },
      female: {
        typ: '02',
        typ_logical_nm: {
          ja: '女性',
          en: 'woman'
        },
        disp_order: 2
      }
    },
    test_cls: {
      test1: {
        typ: '01',
        typ_logical_nm: {
          ja: 'テスト１',
          en: 'test1'
        },
        disp_order: null
      },
      test2: {
        typ: '02',
        typ_logical_nm: {
          ja: 'テスト２',
          en: 'test2'
        },
        disp_order: null
      }
    }
  };

  public static locale: string;

  /**
   * 区分値を配列に変換し、昇順に並び替え
   */
  public static toArray(cls: string): string[] {
    const res: string[] = [];
    for (const key in (<any>this.clsList)[cls]) {
      if (key !== null) {
        res.push((<any>(<any>this.clsList)[cls])[key]);
      }
    }
    return res.sort((a: any, b: any) => a.disp_order - b.disp_order);
  }

  /**
   * 区分値を用いたプルダウンメニューの選択肢を作成
   */
  public static createSelectItems(cls: string): any[] {
    return this.toArray(cls).map((c: any) => ({
      text: c.typ_logical_nm[this.locale],
      value: c.typ
    }));
  }

  /**
   * 区分値のコードを元に名称を取得
   */
  public static getName(cls: string, typ: string): string {
    return this.toArray(cls)
      .filter((c: any) => c.typ === typ)
      .map((c: any) => c.typ_logical_nm[this.locale])
      .toString();
  }
}
